/**
 * How big a yard dinosaur is at each level (docs/mockups/sizes-levels.html),
 * and what that stage of its life is called. From level `level` on it stands
 * `px` pixels tall, given as a size of 64 px art — the last tiers' art is 96,
 * and their sizes scale with it. It used to be one jump, the 32 px yard art to
 * level 9 and the 64 px art from 10; now a dinosaur grows as it levels. The
 * steps come close early, when levels come fast, and four land on the level
 * milestones (10, 25, 50, 100) and share their titles, so the name and the
 * growth arrive together. Sizes without a PNG are resampled (sprites.ts
 * sizedDinoSprite), not redrawn.
 */
const YARD_GROWTH: ReadonlyArray<readonly [level: number, px: number, stage: string]> = [
  [1, 16, 'Hatchling'],
  [3, 21, 'Nestling'],
  [5, 27, 'Yearling'],
  [10, 32, 'Juvenile'],
  [18, 37, 'Adolescent'],
  [25, 43, 'Grown'],
  [35, 48, 'Seasoned'],
  [50, 53, 'Mighty'],
  [75, 59, 'Towering'],
  [100, 64, 'Legendary'],
];

/**
 * The yard size of a dinosaur at `level` whose full art is `full` pixels,
 * never past `room`: a yard too narrow for the next step keeps the last one
 * that fits.
 */
export function yardSizeFor(level: number, full: number, room: number): number {
  let size = Math.round((full * (YARD_GROWTH[0]?.[1] ?? 16)) / 64);
  for (const [threshold, px] of YARD_GROWTH) {
    const s = Math.round((full * px) / 64);
    if (level >= threshold && s <= room) size = s;
  }
  return size;
}

/** The name of the stage a dinosaur at `level` is in, or '' before it hatches. */
export function growthStage(level: number): string {
  let stage = '';
  for (const [threshold, , name] of YARD_GROWTH) if (level >= threshold) stage = name;
  return stage;
}
